/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TenantSlugRouteImport } from './routes/$tenantSlug'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TenantSlugPartnerIndexRouteImport } from './routes/$tenantSlug.partner.index'
import { Route as TenantSlugClientIndexRouteImport } from './routes/$tenantSlug.client.index'
import { Route as TenantSlugPartnerLoginRouteImport } from './routes/$tenantSlug.partner.login'
import { Route as TenantSlugPagesPageSlugRouteImport } from './routes/$tenantSlug.pages.$pageSlug'
import { Route as TenantSlugInvoiceInvoiceIdRouteImport } from './routes/$tenantSlug.invoice.$invoiceId'
import { Route as TenantSlugFormsFormSlugRouteImport } from './routes/$tenantSlug.forms.$formSlug'
import { Route as TenantSlugContentAssetIdRouteImport } from './routes/$tenantSlug.content.$assetId'
import { Route as TenantSlugClientLoginRouteImport } from './routes/$tenantSlug.client.login'
import { Route as TenantSlugAssetsAssetSlugRouteImport } from './routes/$tenantSlug.assets.$assetSlug'
import { Route as TenantSlugRecordEntitySlugRecordIdRouteImport } from './routes/$tenantSlug.record.$entitySlug.$recordId'
import { Route as TenantSlugFormsFormSlugThanksRouteImport } from './routes/$tenantSlug.forms.$formSlug.thanks'

const TenantSlugRoute = TenantSlugRouteImport.update({
  id: '/$tenantSlug',
  path: '/$tenantSlug',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TenantSlugPartnerIndexRoute = TenantSlugPartnerIndexRouteImport.update({
  id: '/partner/',
  path: '/partner/',
  getParentRoute: () => TenantSlugRoute,
} as any)
const TenantSlugClientIndexRoute = TenantSlugClientIndexRouteImport.update({
  id: '/client/',
  path: '/client/',
  getParentRoute: () => TenantSlugRoute,
} as any)
const TenantSlugPartnerLoginRoute = TenantSlugPartnerLoginRouteImport.update({
  id: '/partner/login',
  path: '/partner/login',
  getParentRoute: () => TenantSlugRoute,
} as any)
const TenantSlugPagesPageSlugRoute = TenantSlugPagesPageSlugRouteImport.update({
  id: '/pages/$pageSlug',
  path: '/pages/$pageSlug',
  getParentRoute: () => TenantSlugRoute,
} as any)
const TenantSlugInvoiceInvoiceIdRoute =
  TenantSlugInvoiceInvoiceIdRouteImport.update({
    id: '/invoice/$invoiceId',
    path: '/invoice/$invoiceId',
    getParentRoute: () => TenantSlugRoute,
  } as any)
const TenantSlugFormsFormSlugRoute = TenantSlugFormsFormSlugRouteImport.update({
  id: '/forms/$formSlug',
  path: '/forms/$formSlug',
  getParentRoute: () => TenantSlugRoute,
} as any)
const TenantSlugContentAssetIdRoute =
  TenantSlugContentAssetIdRouteImport.update({
    id: '/content/$assetId',
    path: '/content/$assetId',
    getParentRoute: () => TenantSlugRoute,
  } as any)
const TenantSlugClientLoginRoute = TenantSlugClientLoginRouteImport.update({
  id: '/client/login',
  path: '/client/login',
  getParentRoute: () => TenantSlugRoute,
} as any)
const TenantSlugAssetsAssetSlugRoute =
  TenantSlugAssetsAssetSlugRouteImport.update({
    id: '/assets/$assetSlug',
    path: '/assets/$assetSlug',
    getParentRoute: () => TenantSlugRoute,
  } as any)
const TenantSlugRecordEntitySlugRecordIdRoute =
  TenantSlugRecordEntitySlugRecordIdRouteImport.update({
    id: '/record/$entitySlug/$recordId',
    path: '/record/$entitySlug/$recordId',
    getParentRoute: () => TenantSlugRoute,
  } as any)
const TenantSlugFormsFormSlugThanksRoute =
  TenantSlugFormsFormSlugThanksRouteImport.update({
    id: '/thanks',
    path: '/thanks',
    getParentRoute: () => TenantSlugFormsFormSlugRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$tenantSlug': typeof TenantSlugRouteWithChildren
  '/$tenantSlug/assets/$assetSlug': typeof TenantSlugAssetsAssetSlugRoute
  '/$tenantSlug/client/login': typeof TenantSlugClientLoginRoute
  '/$tenantSlug/content/$assetId': typeof TenantSlugContentAssetIdRoute
  '/$tenantSlug/forms/$formSlug': typeof TenantSlugFormsFormSlugRouteWithChildren
  '/$tenantSlug/invoice/$invoiceId': typeof TenantSlugInvoiceInvoiceIdRoute
  '/$tenantSlug/pages/$pageSlug': typeof TenantSlugPagesPageSlugRoute
  '/$tenantSlug/partner/login': typeof TenantSlugPartnerLoginRoute
  '/$tenantSlug/client/': typeof TenantSlugClientIndexRoute
  '/$tenantSlug/partner/': typeof TenantSlugPartnerIndexRoute
  '/$tenantSlug/forms/$formSlug/thanks': typeof TenantSlugFormsFormSlugThanksRoute
  '/$tenantSlug/record/$entitySlug/$recordId': typeof TenantSlugRecordEntitySlugRecordIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/$tenantSlug': typeof TenantSlugRouteWithChildren
  '/$tenantSlug/assets/$assetSlug': typeof TenantSlugAssetsAssetSlugRoute
  '/$tenantSlug/client/login': typeof TenantSlugClientLoginRoute
  '/$tenantSlug/content/$assetId': typeof TenantSlugContentAssetIdRoute
  '/$tenantSlug/forms/$formSlug': typeof TenantSlugFormsFormSlugRouteWithChildren
  '/$tenantSlug/invoice/$invoiceId': typeof TenantSlugInvoiceInvoiceIdRoute
  '/$tenantSlug/pages/$pageSlug': typeof TenantSlugPagesPageSlugRoute
  '/$tenantSlug/partner/login': typeof TenantSlugPartnerLoginRoute
  '/$tenantSlug/client': typeof TenantSlugClientIndexRoute
  '/$tenantSlug/partner': typeof TenantSlugPartnerIndexRoute
  '/$tenantSlug/forms/$formSlug/thanks': typeof TenantSlugFormsFormSlugThanksRoute
  '/$tenantSlug/record/$entitySlug/$recordId': typeof TenantSlugRecordEntitySlugRecordIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$tenantSlug': typeof TenantSlugRouteWithChildren
  '/$tenantSlug/assets/$assetSlug': typeof TenantSlugAssetsAssetSlugRoute
  '/$tenantSlug/client/login': typeof TenantSlugClientLoginRoute
  '/$tenantSlug/content/$assetId': typeof TenantSlugContentAssetIdRoute
  '/$tenantSlug/forms/$formSlug': typeof TenantSlugFormsFormSlugRouteWithChildren
  '/$tenantSlug/invoice/$invoiceId': typeof TenantSlugInvoiceInvoiceIdRoute
  '/$tenantSlug/pages/$pageSlug': typeof TenantSlugPagesPageSlugRoute
  '/$tenantSlug/partner/login': typeof TenantSlugPartnerLoginRoute
  '/$tenantSlug/client/': typeof TenantSlugClientIndexRoute
  '/$tenantSlug/partner/': typeof TenantSlugPartnerIndexRoute
  '/$tenantSlug/forms/$formSlug/thanks': typeof TenantSlugFormsFormSlugThanksRoute
  '/$tenantSlug/record/$entitySlug/$recordId': typeof TenantSlugRecordEntitySlugRecordIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$tenantSlug'
    | '/$tenantSlug/assets/$assetSlug'
    | '/$tenantSlug/client/login'
    | '/$tenantSlug/content/$assetId'
    | '/$tenantSlug/forms/$formSlug'
    | '/$tenantSlug/invoice/$invoiceId'
    | '/$tenantSlug/pages/$pageSlug'
    | '/$tenantSlug/partner/login'
    | '/$tenantSlug/client/'
    | '/$tenantSlug/partner/'
    | '/$tenantSlug/forms/$formSlug/thanks'
    | '/$tenantSlug/record/$entitySlug/$recordId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/$tenantSlug'
    | '/$tenantSlug/assets/$assetSlug'
    | '/$tenantSlug/client/login'
    | '/$tenantSlug/content/$assetId'
    | '/$tenantSlug/forms/$formSlug'
    | '/$tenantSlug/invoice/$invoiceId'
    | '/$tenantSlug/pages/$pageSlug'
    | '/$tenantSlug/partner/login'
    | '/$tenantSlug/client'
    | '/$tenantSlug/partner'
    | '/$tenantSlug/forms/$formSlug/thanks'
    | '/$tenantSlug/record/$entitySlug/$recordId'
  id:
    | '__root__'
    | '/'
    | '/$tenantSlug'
    | '/$tenantSlug/assets/$assetSlug'
    | '/$tenantSlug/client/login'
    | '/$tenantSlug/content/$assetId'
    | '/$tenantSlug/forms/$formSlug'
    | '/$tenantSlug/invoice/$invoiceId'
    | '/$tenantSlug/pages/$pageSlug'
    | '/$tenantSlug/partner/login'
    | '/$tenantSlug/client/'
    | '/$tenantSlug/partner/'
    | '/$tenantSlug/forms/$formSlug/thanks'
    | '/$tenantSlug/record/$entitySlug/$recordId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  TenantSlugRoute: typeof TenantSlugRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$tenantSlug': {
      id: '/$tenantSlug'
      path: '/$tenantSlug'
      fullPath: '/$tenantSlug'
      preLoaderRoute: typeof TenantSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$tenantSlug/partner/': {
      id: '/$tenantSlug/partner/'
      path: '/partner'
      fullPath: '/$tenantSlug/partner/'
      preLoaderRoute: typeof TenantSlugPartnerIndexRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/client/': {
      id: '/$tenantSlug/client/'
      path: '/client'
      fullPath: '/$tenantSlug/client/'
      preLoaderRoute: typeof TenantSlugClientIndexRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/partner/login': {
      id: '/$tenantSlug/partner/login'
      path: '/partner/login'
      fullPath: '/$tenantSlug/partner/login'
      preLoaderRoute: typeof TenantSlugPartnerLoginRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/pages/$pageSlug': {
      id: '/$tenantSlug/pages/$pageSlug'
      path: '/pages/$pageSlug'
      fullPath: '/$tenantSlug/pages/$pageSlug'
      preLoaderRoute: typeof TenantSlugPagesPageSlugRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/invoice/$invoiceId': {
      id: '/$tenantSlug/invoice/$invoiceId'
      path: '/invoice/$invoiceId'
      fullPath: '/$tenantSlug/invoice/$invoiceId'
      preLoaderRoute: typeof TenantSlugInvoiceInvoiceIdRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/forms/$formSlug': {
      id: '/$tenantSlug/forms/$formSlug'
      path: '/forms/$formSlug'
      fullPath: '/$tenantSlug/forms/$formSlug'
      preLoaderRoute: typeof TenantSlugFormsFormSlugRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/content/$assetId': {
      id: '/$tenantSlug/content/$assetId'
      path: '/content/$assetId'
      fullPath: '/$tenantSlug/content/$assetId'
      preLoaderRoute: typeof TenantSlugContentAssetIdRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/client/login': {
      id: '/$tenantSlug/client/login'
      path: '/client/login'
      fullPath: '/$tenantSlug/client/login'
      preLoaderRoute: typeof TenantSlugClientLoginRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/assets/$assetSlug': {
      id: '/$tenantSlug/assets/$assetSlug'
      path: '/assets/$assetSlug'
      fullPath: '/$tenantSlug/assets/$assetSlug'
      preLoaderRoute: typeof TenantSlugAssetsAssetSlugRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/record/$entitySlug/$recordId': {
      id: '/$tenantSlug/record/$entitySlug/$recordId'
      path: '/record/$entitySlug/$recordId'
      fullPath: '/$tenantSlug/record/$entitySlug/$recordId'
      preLoaderRoute: typeof TenantSlugRecordEntitySlugRecordIdRouteImport
      parentRoute: typeof TenantSlugRoute
    }
    '/$tenantSlug/forms/$formSlug/thanks': {
      id: '/$tenantSlug/forms/$formSlug/thanks'
      path: '/thanks'
      fullPath: '/$tenantSlug/forms/$formSlug/thanks'
      preLoaderRoute: typeof TenantSlugFormsFormSlugThanksRouteImport
      parentRoute: typeof TenantSlugFormsFormSlugRoute
    }
  }
}

interface TenantSlugFormsFormSlugRouteChildren {
  TenantSlugFormsFormSlugThanksRoute: typeof TenantSlugFormsFormSlugThanksRoute
}

const TenantSlugFormsFormSlugRouteChildren: TenantSlugFormsFormSlugRouteChildren =
  {
    TenantSlugFormsFormSlugThanksRoute: TenantSlugFormsFormSlugThanksRoute,
  }

const TenantSlugFormsFormSlugRouteWithChildren =
  TenantSlugFormsFormSlugRoute._addFileChildren(
    TenantSlugFormsFormSlugRouteChildren,
  )

interface TenantSlugRouteChildren {
  TenantSlugAssetsAssetSlugRoute: typeof TenantSlugAssetsAssetSlugRoute
  TenantSlugClientLoginRoute: typeof TenantSlugClientLoginRoute
  TenantSlugContentAssetIdRoute: typeof TenantSlugContentAssetIdRoute
  TenantSlugFormsFormSlugRoute: typeof TenantSlugFormsFormSlugRouteWithChildren
  TenantSlugInvoiceInvoiceIdRoute: typeof TenantSlugInvoiceInvoiceIdRoute
  TenantSlugPagesPageSlugRoute: typeof TenantSlugPagesPageSlugRoute
  TenantSlugPartnerLoginRoute: typeof TenantSlugPartnerLoginRoute
  TenantSlugClientIndexRoute: typeof TenantSlugClientIndexRoute
  TenantSlugPartnerIndexRoute: typeof TenantSlugPartnerIndexRoute
  TenantSlugRecordEntitySlugRecordIdRoute: typeof TenantSlugRecordEntitySlugRecordIdRoute
}

const TenantSlugRouteChildren: TenantSlugRouteChildren = {
  TenantSlugAssetsAssetSlugRoute: TenantSlugAssetsAssetSlugRoute,
  TenantSlugClientLoginRoute: TenantSlugClientLoginRoute,
  TenantSlugContentAssetIdRoute: TenantSlugContentAssetIdRoute,
  TenantSlugFormsFormSlugRoute: TenantSlugFormsFormSlugRouteWithChildren,
  TenantSlugInvoiceInvoiceIdRoute: TenantSlugInvoiceInvoiceIdRoute,
  TenantSlugPagesPageSlugRoute: TenantSlugPagesPageSlugRoute,
  TenantSlugPartnerLoginRoute: TenantSlugPartnerLoginRoute,
  TenantSlugClientIndexRoute: TenantSlugClientIndexRoute,
  TenantSlugPartnerIndexRoute: TenantSlugPartnerIndexRoute,
  TenantSlugRecordEntitySlugRecordIdRoute:
    TenantSlugRecordEntitySlugRecordIdRoute,
}

const TenantSlugRouteWithChildren = TenantSlugRoute._addFileChildren(
  TenantSlugRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TenantSlugRoute: TenantSlugRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
